module.exports = __webpack_public_path__ + "img/geology-mars.830f3335.png";